import {Image} from "@fluentui/react-components";
import {propsType} from "../../../Avatye";
import React, {useEffect, useState} from "react";
import {greenTheme} from "../../../../../../styles/mission/theme";
import {isVisible} from "../../../../../../utils/bitmask";
import DefaultImg from '../../../../../../assets/iconImg/defaultImg.png'
import {ShoppingPresentationValueObject} from "../../../../../../model/vo/content/ShoppingPresentationValueObject";
import AlertDialog from "../../common/AlertDialog";
import {ExhaustedPage} from "../../../../common/ExhaustedPage";
import {formatRank} from "../../../../../../utils/rank";
import {ChatBubblesQuestionRegular} from "@fluentui/react-icons";
import {formatProductName, formatStoreName} from "../../../../../../utils/store";
import {formatNumber} from "../../../../../../utils/price";
import AnswerInput from "../../common/AnswerInput";
import TitleBar from "../../common/TitleBar";
import {useStyles} from "../../../../../../styles/mission/ver1";
import {Column} from "../../../../common/Layout";
import OtherMissionBtn from "../../common/OtherMissionBtn";
import {ErrorPage} from "../../../../common/ErrorPage";
import {PathTypeString} from "../../../../../../constant/pathType";
import {setPathType} from "../../../../../../utils/pathType";
import StyledPathText from "../../../../../../components/mission/common/StyledPathText";

export default function Mission(
    {props,data,isLoading,primaryColor,otherMissionBtnClick}:
{
    props:propsType,
    data:ShoppingPresentationValueObject | null,
    isLoading:boolean,
    primaryColor:string,
    otherMissionBtnClick:()=>void
}) {
    const {mediaCode,campaignCode,campaignID,payload,uk,adFallBack} = props;

    const styles = useStyles();
    const color = greenTheme;

    const [isEnd, setIsEnd] = useState(false)
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState<string>('')
    const [dialogMsg, setDialogMsg] = useState<string>('')

    const openDialog = (title: string, content: string) => {
        try {
            setDialogTitle(title)
            setDialogMsg(content)
        } finally {
            setIsDialogOpen(true)
        }
    }

    const closeDialog = () => setIsDialogOpen(false)

    useEffect(() => {
        const handleCopy = (e: ClipboardEvent) => {
            e.preventDefault()
            openDialog(
                '경고',
                '복사가 금지되어 있습니다.\n하단의 버튼을 이용해서 미션을 진행해주세요!',
            )
        }

        document.addEventListener('copy', handleCopy)

        return () => {
            document.removeEventListener('copy', handleCopy)
        }
    }, [])


    return (
        (!data || !data.visibility) ?
            <ErrorPage />
            :
        <>
            <AlertDialog
                title={dialogTitle}
                description={dialogMsg}
                isOpen={isDialogOpen}
                onClose={closeDialog}
            />

            <main className={styles.main} style={{fontFamily: 'NanumBarunGothic',}}>
                <div style={{margin: '20px'}}>

                    <div style={{height: '50px'}}/>

                    <TitleBar title={data.title || ''}/>

                    <Column justifyContent={'center'} alignItems={'center'} marginBottom={'8px'}>
                        <div className={styles.guideMessage} style={{color:primaryColor}}>
                            {PathTypeString[setPathType(data.pathType)].split('\n').map((v) => <StyledPathText str={v}  />)}
                        </div>
                    </Column>

                    <Column gap={'12px'}>
                        {/* Product Info Card */}
                        <div className={styles.productCard}>
                            {isVisible(data.visibility, 4) && (
                                <div className={styles.productImg}>
                                    <Image
                                        alt="상품이미지"
                                        src={data.productImageUrl || DefaultImg}
                                        width={100}
                                        height={100}
                                    />
                                </div>
                            )}

                            <div className={styles.productInfo}>
                                {isVisible(data.visibility, 5) && (
                                    <>
                                        <div className={styles.title}>
                                            <div className={styles.productLabel}>
                                                현재 순위
                                            </div>
                                        </div>
                                        <div className={styles.description}
                                             style={{color: '#f87171'}}>{formatRank(data.rank || 0)+' 위'}</div>
                                    </>
                                )}
                                {isVisible(data.visibility, 3) && (
                                    <>
                                        <div className={styles.title}>
                                            <div className={styles.productLabel}>
                                                키워드
                                            </div>
                                        </div>
                                        <div className={styles.description}
                                             style={{color: '#f87171'}}>{data.mainKeyword}</div>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Hint */}
                        {
                            (isVisible(data.visibility, 1) || isVisible(data.visibility, 0)) && (

                                <div className={styles.hintCard}>
                                    <div className={styles.title}>
                                        <div className={styles.productLabel}
                                             style={{
                                                 backgroundColor: primaryColor,
                                                 display: 'flex',
                                                 gap: '3px',
                                                 color: 'white',
                                                 fontSize: 'medium'
                                             }}>
                                            <ChatBubblesQuestionRegular/>
                                            힌트
                                        </div>
                                    </div>
                                    <div style={{display: 'flex', gap: '10px', color: '#6b7280'}}>
                                        {isVisible(data.visibility, 1) && (
                                            <>
                                                <div className={styles.title}>
                                                    <div className={styles.productLabel}
                                                         style={{
                                                             backgroundColor: '#6b7280',
                                                             color: 'white',
                                                             fontSize: 'medium'
                                                         }}>
                                                        상품명
                                                    </div>
                                                </div>
                                                <div
                                                    className={styles.description} style={{
                                                    color: '#6b7280',
                                                    fontSize: 'medium'
                                                }}>{formatProductName(data.productName || '', data.storeName || '')}</div>
                                            </>
                                        )}
                                    </div>
                                    <div style={{display: 'flex', gap: '10px'}}>
                                        {isVisible(data.visibility, 0) && (
                                            <>
                                                <div className={styles.title}>
                                                    <div className={styles.productLabel}
                                                         style={{
                                                             backgroundColor: '#6b7280',
                                                             color: 'white',
                                                             fontSize: 'medium'
                                                         }}>
                                                        스토어명
                                                    </div>
                                                </div>
                                                <div
                                                    className={styles.description} style={{
                                                    color: '#6b7280',
                                                    fontSize: 'medium'
                                                }}>{formatStoreName(data.storeName || '')}</div>
                                            </>
                                        )}
                                    </div>

                                    <div style={{display: 'flex', gap: '10px'}}>
                                        {isVisible(data.visibility, 2) && (
                                            <>
                                                <div className={styles.title}>
                                                    <div className={styles.productLabel}
                                                         style={{
                                                             backgroundColor: '#6b7280',
                                                             color: 'white',
                                                             fontSize: 'medium'
                                                         }}>
                                                        가격
                                                    </div>
                                                </div>
                                                <div
                                                    className={styles.description} style={{
                                                    color: '#6b7280',
                                                    fontSize: 'medium'
                                                }}>{formatNumber(data.productPrice || 0) + '원'}</div>
                                            </>
                                        )}
                                    </div>

                                </div>
                            )
                        }
                        <OtherMissionBtn onClick={otherMissionBtnClick}/>
                    </Column>
                    <div style={{height: '150px'}}/>
                </div>
            </main>

            {
            data.shoppingPathJointId && data.userId && (
                    <div className={styles.fixedBottom} style={{backgroundColor:greenTheme.bgColor100}}>
                        <AnswerInput
                            mediaCode={mediaCode || ''}
                            shoppingPathJointId={data.shoppingPathJointId}
                            userId={data.userId}
                            mediaId={payload || ''}
                            data={data}
                            primaryColor={primaryColor}
                        />
                    </div>
                )
            }

        </>
    )
        ;

}